import React, { useEffect } from "react";
import { useAuth } from "../App";
import { setupResponseInterceptors } from "../services/api";
import { useToast } from "../contexts/ToastContext";

const ApiProvider = ({ children }) => {
  const auth = useAuth();
  const toast = useToast();

  useEffect(() => {
    setupResponseInterceptors(auth, toast);
  }, [auth, toast]);

  return <>{children}</>;
};

export default ApiProvider;
